/**
 * Sprint 36, story-184. Maps a plan draft's stable `errorCode` to `aiPlan` locale keys. Clients
 * key on the code and never print the server's `errorMessage`. Unknown or missing codes fall
 * back to the generic copy.
 */
export interface PlanErrorCopyKeys {
  titleKey: 'errUnavailableTitle' | 'errBusyTitle' | 'errGenericTitle';
  bodyKey: 'errUnavailableBody' | 'errBusyBody' | 'errGenericBody';
  /** BILLING/AUTH may keep failing until an admin fixes it, so Retry is secondary there. */
  retryStyle: 'primary' | 'secondary';
}

export function planErrorCopy(errorCode?: string | null): PlanErrorCopyKeys {
  switch (errorCode) {
    case 'AI_PLANNING_BILLING':
    case 'AI_PLANNING_AUTH':
      return { titleKey: 'errUnavailableTitle', bodyKey: 'errUnavailableBody', retryStyle: 'secondary' };
    case 'AI_PLANNING_RATE_LIMITED':
      return { titleKey: 'errBusyTitle', bodyKey: 'errBusyBody', retryStyle: 'primary' };
    default:
      return { titleKey: 'errGenericTitle', bodyKey: 'errGenericBody', retryStyle: 'primary' };
  }
}
